const BuildingIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 21V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v15M4 21h16M9 9h.01M15 9h.01M9 13h.01M15 13h.01M9 17h6" stroke="#6B7280" strokeWidth="1.6" strokeLinecap="round"/>
  </svg>
)

export default BuildingIcon
